// Central brand contact info — used across cart, WhatsApp CTAs, footer & schema
export const BRAND_PHONE_DISPLAY = "+91-7982444690";
export const BRAND_PHONE_E164 = "+917982444690";
export const BRAND_WHATSAPP = "917982444690"; // wa.me format (no + or dashes)
export const BRAND_EMAIL = "info@sanatandharmaonline.com";
export const BRAND_NAME = "Sanatan Dharma";

/**
 * Format a price value with ₹ symbol. Accepts "199", "₹199", "₹ 199", 199, etc.
 * Returns an empty string if the value is empty/undefined.
 */
export function formatPrice(value) {
  if (value === null || value === undefined) return "";
  const s = String(value).trim();
  if (!s) return "";
  if (s.startsWith("₹")) return s;
  const n = parseFloat(s.replace(/[^\d.]/g, ""));
  if (Number.isNaN(n)) return s;
  return `₹ ${n.toLocaleString("en-IN")}`;
}

/**
 * Get the price for a specific size from a product. Falls back to base price.
 */
export function priceForSize(product, size) {
  if (!product) return "";
  const vp = product.variant_prices || {};
  return vp[size] || product.price || "";
}

/**
 * Get the lowest / starting price across variants for a product card display.
 */
export function startingPrice(product) {
  if (!product) return "";
  const vp = product.variant_prices || {};
  const values = Object.values(vp)
    .map((v) => parseFloat(String(v).replace(/[^\d.]/g, "")))
    .filter((n) => !Number.isNaN(n));
  if (values.length === 0) return product.price || "";
  return String(Math.min(...values));
}

/**
 * Build a wa.me URL with a pre-filled message.
 */
export function buildWhatsAppUrl(message) {
  return `https://wa.me/${BRAND_WHATSAPP}?text=${encodeURIComponent(message)}`;
}

/**
 * Compose a nicely formatted WhatsApp order message from cart items.
 */
export function buildOrderMessage(items, customer = {}) {
  const lines = ["*New Order — Sanatan Dharma*", ""];
  let total = 0;
  items.forEach((it, i) => {
    const unit = parseFloat(String(it.price || "").replace(/[^\d.]/g, "")) || 0;
    const line = unit * (it.qty || 1);
    total += line;
    lines.push(`${i + 1}. ${it.name}${it.size ? ` (${it.size})` : ""} × ${it.qty}${unit ? `  — ₹${line.toLocaleString("en-IN")}` : ""}`);
  });
  if (total > 0) {
    lines.push("", `*Estimated Total: ₹${total.toLocaleString("en-IN")}*`);
  }
  if (customer.name || customer.phone || customer.address) {
    lines.push("", "*Delivery Details*");
    if (customer.name) lines.push(`Name: ${customer.name}`);
    if (customer.phone) lines.push(`Phone: ${customer.phone}`);
    if (customer.address) lines.push(`Address: ${customer.address}`);
    if (customer.city || customer.pincode) lines.push(`City / PIN: ${customer.city || ""} ${customer.pincode || ""}`.trim());
  }
  lines.push("", "Please confirm availability and delivery timeline. Thank you.");
  return lines.join("\n");
}
